import { useTenantSetting } from "@nestoca/multi-tenant";
import { OptionItem } from "@shared/ui";
import { useTranslation } from "react-i18next";

import { LENDERS, MORTGAGE_LENDER_LABELS } from "./lenders";
import { sortLenderOptions } from "./sort-lender-options";

export const useOwnedPropertyLenderOptions = (): OptionItem[] => {
  const { settings } = useTenantSetting("typesOverride");
  const mortgageLenders = settings.mortgageLenderTypes;

  const { t } = useTranslation("common");

  if (!mortgageLenders) {
    return sortLenderOptions(
      LENDERS.map((option) => ({
        value: option.value,
        label: t(option.label),
      }))
    );
  }

  return sortLenderOptions(
    mortgageLenders.map((type) => ({
      value: type,
      label: t(MORTGAGE_LENDER_LABELS[type]),
    }))
  );
};
